<template>
  <div class="Texto">
    <h6>Agregar Texto</h6>
    <b-form @submit="AddTexto">
      <b-form-row>
        <b-col>
          <b-form-group size="sm" style="font-size:12px" label="Color:">
            <verte v-model="color" picker="square" model="rgb" ref="txtColor"></verte>
          </b-form-group>
        </b-col>
        <b-col >
          <b-form-group size="sm" style="font-size:12px" label="Fuente:">
            <div id="font-picker"></div>
            <b-form-select v-model="selectedFont" :options="optionsFont" size="sm" ref="txtFuente"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col >
          <b-form-group size="sm" style="font-size:12px" label="Tamaño:">
            <b-form-select v-model="selectedSize" :options="optionsSize" size="sm" ref="txtSize"></b-form-select>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col >
          <b-form-textarea
            v-model="texto"
            placeholder="Ingrese texto..."
            rows="1"
            size="sm"
            max-rows="1"
            :state="TextValidation"
          ></b-form-textarea>
          <b-form-invalid-feedback :state="TextValidation">Debe ingresar un texto para agregar.</b-form-invalid-feedback>
          <b-form-valid-feedback :state="TextValidation"></b-form-valid-feedback>
        </b-col>
        <b-col>
          <b-button style="margin-top:24px;" variant="outline-success" size="sm" type="submit">
            <b-icon icon="arrow-up"></b-icon>
          </b-button>
        </b-col>
      </b-form-row>
    </b-form>
    <b-modal id="modal-editar-texto" title="Editar texto seleccionado">
      <b-form>
        <b-form-row>
          <b-col >
            <b-form-group size="sm" style="font-size:12px" label="Color:">
              <verte v-model="color" picker="square" model="rgb" ref="txtColor"></verte>
            </b-form-group>
          </b-col>
          <b-col >
            <b-form-group size="sm" style="font-size:12px" label="Fuente:">
              <div id="font-picker"></div>
              <b-form-select
                v-model="selectedFont"
                :options="optionsFont"
                size="sm"
                ref="txtFuente"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group size="sm" style="font-size:12px" label="Tamaño:">
              <b-form-select v-model="selectedSize" :options="optionsSize" size="sm" ref="txtSize"></b-form-select>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-form-textarea
              v-model="texto"
              placeholder="Ingrese texto..."
              rows="1"
              size="sm"
              max-rows="1"
              :state="TextValidation"
              ref="txtTexto"
            ></b-form-textarea>
            <b-form-invalid-feedback :state="TextValidation">Debe ingresar un texto para agregar.</b-form-invalid-feedback>
            <b-form-valid-feedback :state="TextValidation"></b-form-valid-feedback>
          </b-col>
        </b-form-row>
      </b-form>
      <template v-slot:modal-footer>
        <b-button variant="outline-info" size="sm" type="button" @click="EditTexto">Actualizar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function () {
    return {
      color: "black",
      id: null,
      selectedFontdefault: null,
      selectedFont: null,
      optionsFont: [],
      selectedSize: 10,
      optionsSize: [
        7,
        8,
        9,
        10,
        11,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30,
        32,
        34,
        36,
        38,
        40,
        42,
        44,
        46,
        48,
        50,
        60,
        70,
        80,
        90,
        100,
      ],
      texto: "",
      validar: false,
    };
  },
  computed: {
    TextValidation() {
      if (!this.valida) {
        return null;
      }

      return this.texto.length > 0;
    },
    valida: {
      get: function () {
        return this.validar;
      },
      set: function (valor) {
        this.validar = valor;
      },
    },
  },
  created() {
    this.obtenerFuentes();
  },
  methods: {
    addGoogleFont(FontName) {},
    obtenerFuentes() {
      axios
        .get(
          "https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyDohORtZQuolonqRzCjokTzEiD0Q0JzT2I"
        )
        .then((response) => {
          const ls = new Array();

          $(response.data.items).each(function (i, item) {
            let FontName = item.family.replace(" ", "+");
            const oitem = new Object();
            oitem.value = "'"+item.family+"'";
            oitem.text = item.family;
            ls.push(oitem);
            $("head").append(
              "<link href='https://fonts.googleapis.com/css?family=" +
                FontName +
                "' rel='stylesheet' type='text/css'>"
            );
          });
            this.selectedFontdefault = "'" + response.data.items[0].family + "'"; 
            this.selectedFont = "'" + response.data.items[0].family+ "'"; 
            this.optionsFont = ls;
           

        })
        .catch((e) => {
          console.log(e.response);
        });
    },
    AddTexto(evt) {
      evt.preventDefault();
      this.valida = true;
      if (this.TextValidation) {
          const obj = {
              fontSize : this.selectedSize,
              fontFamily : this.selectedFont ,
              color: this.color,
              text : this.texto
          }
       

          this.valida = false;
          this.texto = "";
          this.$emit("AddTexto", obj);

      }
    },
    EditTexto(evt) {
      evt.preventDefault();
      this.valida = true;
      if (this.TextValidation) {
          const obj = {
              fontSize: this.selectedSize,
              fontFamily: this.selectedFont,
              color: this.color,
              text: this.texto,
              id : this.id
          }
       
      
        this.selectedFont = this.selectedFontdefault;
        this.selectedSize = 10;
        this.color = "black";
        this.texto = "";
        this.valida = false;
        this.id = null;
        this.$emit("EditTexto", obj);
        this.$bvModal.hide("modal-editar-texto");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
